var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.19043,64.75H67.80957A2.94421,2.94421,0,0,0,70.75,61.80908V20.19092A2.94421,2.94421,0,0,0,67.80957,17.25H56.75V14h-1.5v3.25H24.75V14h-1.5v3.25H12.19043A2.94421,2.94421,0,0,0,9.25,20.19092V61.80908A2.94421,2.94421,0,0,0,12.19043,64.75ZM10.75,20.19092A1.44256,1.44256,0,0,1,12.19043,18.75H23.25V22h1.5V18.75h30.5V22h1.5V18.75H67.80957A1.44256,1.44256,0,0,1,69.25,20.19092v6.86816H10.75Zm0,8.36816h58.5v33.25A1.44256,1.44256,0,0,1,67.80957,63.25H12.19043A1.44256,1.44256,0,0,1,10.75,61.80908Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,54.75A4.75,4.75,0,1,0,45.25,50,4.7554,4.7554,0,0,0,50,54.75Zm0-8A3.25,3.25,0,1,1,46.75,50,3.25377,3.25377,0,0,1,50,46.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 34,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 34,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 34,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 34,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 34,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 42,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 42,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42,
    r: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 42,
    r: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 50,
    r: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    r: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 58,
    r: 1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 58,
    r: 1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 58,
    r: 1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 58,
    r: 1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 58,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon_event.3e253989b23637acce07a0ca7d2cd0aa.svg";
export { ForwardRef as ReactComponent };